import React from 'react'
import {SOCIAL_LINKS,CONTACT_EMAIL} from '../socialLinks'

export default function ContactSection() {
    return (
        <section id='contact' className='py-20 w-full text-center bg-dark lg:py-28'>
            <h2 className='text-3xl font-bold text-light font-display lg:text-5xl'>Get in touch</h2>
            <a
                href={`mailto:${CONTACT_EMAIL}`}
                className='inline-block mt-6 text-lg font-semibold transition-colors text-dark-300 hover:text-light lg:text-xl'
            >
                {CONTACT_EMAIL}
            </a>
            <div className='flex gap-4 justify-center items-center mt-8'>
                {SOCIAL_LINKS.map(social => (
                    <a
                        key={social.name}
                        href={social.href}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label={social.name}
                        className='flex justify-center items-center w-11 h-11 rounded-full border transition-colors border-dark-700 text-light hover:text-accent hover:border-accent'
                    >
                        {social.icon}
                    </a>
                ))}
            </div>
        </section>
    )
}
